import React, { useState } from 'react';
import { IDevice } from '../../interfaces';
import { Circle, GoogleApiWrapper, Map, Marker } from 'google-maps-react';

const MapsFixed = Map as any;
const MarkerFixed = Marker as any;

class MapContainer extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {};
    }

    render() {
        const shops: any = {};

        for (const d of this.props.devices) {
            if (d && !shops[d.Shop.id]) {
                shops[d.Shop.id] = d.Shop;
            }
        }

        return (
            <MapsFixed
                containerStyle={{
                    position: 'relative',
                    width: '100%',
                    height: '100%'
                }}
                zoom={11}
                initialCenter={{ lat: 48.8588377, lng: 2.2770207 }}
                google={this.props.google}
                style={{ height: '100%', width: '100%', position: 'relative' }}
            >
                {Object.values(shops).map((s: any) => (
                    <MarkerFixed
                        key={s.id}
                        position={{
                            lat: parseFloat(s.lat),
                            lng: parseFloat(s.long)
                        }}
                    />
                ))}
                {(this.props.zones || []).map((z: any, i: number) => (
                    <Circle key={i} radius={this.props.radius || 100} center={{ lat: z.lat, lng: z.lng }} />
                ))}
            </MapsFixed>
        );
    }
}

export const MapWrapper = GoogleApiWrapper({
    apiKey: 'AIzaSyAWfIRigNcERfybYb4_YEmOxY3GEFH9tq4'
})(MapContainer);

export const MapView = (props: { devices: IDevice[]; close: () => void }) => {
    const [state, setState] = useState({
        closing: false
    });

    return (
        <div
            className={`modal-background${state.closing ? ' closing' : ''}`}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    setState({
                        ...state,
                        closing: true
                    });

                    setTimeout(props.close, 200);
                }
            }}
        >
            <div className="modal">
                <div className="content-map">
                    <h6>Carte</h6>
                    <div className="map">
                        <MapWrapper devices={props.devices} />
                    </div>
                </div>
            </div>
        </div>
    );
};
